import React from 'react';

const IcCalendarNeutral = ({ width, height, color }: { width?: string; height?: string; color?: string }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.12265 6.7334C2.9901 6.7334 2.88265 6.84085 2.88265 6.9734V7.84273C2.88265 7.97528 2.9901 8.08273 3.12265 8.08273H3.99198C4.12453 8.08273 4.23198 7.97528 4.23198 7.84273V6.9734C4.23198 6.84085 4.12453 6.7334 3.99198 6.7334H3.12265Z'
                fill='#989BA2'
            />
            <path
                d='M2.88265 9.30409C2.88265 9.17154 2.9901 9.06409 3.12265 9.06409H3.99198C4.12453 9.06409 4.23198 9.17154 4.23198 9.30409V10.1734C4.23198 10.306 4.12453 10.4134 3.99198 10.4134H3.12265C2.9901 10.4134 2.88265 10.306 2.88265 10.1734V9.30409Z'
                fill='#989BA2'
            />
            <path
                d='M5.69882 6.7334C5.56627 6.7334 5.45882 6.84085 5.45882 6.9734V7.84273C5.45882 7.97528 5.56627 8.08273 5.69882 8.08273H6.56815C6.7007 8.08273 6.80816 7.97528 6.80816 7.84273V6.9734C6.80816 6.84085 6.7007 6.7334 6.56815 6.7334H5.69882Z'
                fill='#989BA2'
            />
            <path
                d='M5.45882 9.30409C5.45882 9.17154 5.56627 9.06409 5.69882 9.06409H6.56815C6.7007 9.06409 6.80816 9.17154 6.80816 9.30409V10.1734C6.80816 10.306 6.7007 10.4134 6.56815 10.4134H5.69882C5.56627 10.4134 5.45882 10.306 5.45882 10.1734V9.30409Z'
                fill='#989BA2'
            />
            <path
                d='M8.27483 6.7334C8.14228 6.7334 8.03483 6.84085 8.03483 6.9734V7.84273C8.03483 7.97528 8.14228 8.08273 8.27483 8.08273H9.14416C9.27671 8.08273 9.38416 7.97528 9.38416 7.84273V6.9734C9.38416 6.84085 9.27671 6.7334 9.14416 6.7334H8.27483Z'
                fill='#989BA2'
            />
            <path
                d='M8.03483 9.30409C8.03483 9.17154 8.14228 9.06409 8.27483 9.06409H9.14416C9.27671 9.06409 9.38416 9.17154 9.38416 9.30409V10.1734C9.38416 10.306 9.27671 10.4134 9.14416 10.4134H8.27483C8.14228 10.4134 8.03483 10.306 8.03483 10.1734V9.30409Z'
                fill='#989BA2'
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M3.88741 1.2134C3.88741 0.948302 3.67251 0.733398 3.40741 0.733398C3.14231 0.733398 2.92741 0.948302 2.92741 1.2134V1.8267H1.2C0.537258 1.8267 0 2.36396 0 3.0267V11.6667C0 12.3294 0.537257 12.8667 1.2 12.8667H11.0667C11.7294 12.8667 12.2667 12.3294 12.2667 11.6667V3.0267C12.2667 2.36396 11.7294 1.8267 11.0667 1.8267H9.33923V1.2134C9.33923 0.948302 9.12433 0.733398 8.85923 0.733398C8.59414 0.733398 8.37923 0.948302 8.37923 1.2134V1.8267H3.88741V1.2134ZM1.2 2.7867H11.0667C11.1992 2.7867 11.3067 2.89415 11.3067 3.0267V4.54968H0.96V3.0267C0.96 2.89415 1.06745 2.7867 1.2 2.7867ZM0.96 5.50968V11.6667C0.96 11.7993 1.06745 11.9067 1.2 11.9067H11.0667C11.1992 11.9067 11.3067 11.7992 11.3067 11.6667V5.50968H0.96Z'
                fill='#989BA2'
            />
        </svg>
    );
};

export default IcCalendarNeutral;
